<template>
  <v-card
    class="mb-2 pa-2"
    light
  >
    <div v-if="client">
      {{ $t('field.client') }}: {{ client }}
    </div>
    <div v-if="cardType">
      {{ $t('field.type_carte') }}: {{ cardType }}
    </div>
    <div v-if="date">
      {{ $t('field.date_fin_validite') }}: {{ $formatDate(date) }}
    </div>
    <div v-if="amount">
      {{ $t('words.amount') }}: {{ amount }}
    </div>

    <v-divider class="my-1" />

    <div>{{ $t('field.amount_credited') }}: {{ totalAmount }}</div>
    <div>{{ $t('field.nbr_credited') }}: {{ total }}</div>

    <v-btn
      v-if="total > 0"
      class="mt-3"
      block
      color="green"
      @click="$emit('valid')"
    >
      {{ $t('button.finish_session') }}
    </v-btn>
  </v-card>
</template>

<script>
import { $formatDate } from '@/modules/Utils'

export default {
  name: 'RecursiveCard',

  props: {
    client: { type: String, default: null },
    cardType: { type: String, default: null },
    date: { type: String, default: null },
    amount: { type: String, default: null },
    //
    total: { type: Number, default: 0 },
    totalAmount: { type: String, default: '0' }
  },

  methods: {
    $formatDate
  }
}
</script>
